import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CacheService } from './cache.service';
import { EnvironmentService } from './environment.service';
import { FeatureDetectService } from './feature-detect.service';
import { GuardModule } from './guards';
import { MddHttpService } from './mdd-http.service';
import { MediaQueryService } from './media-query.service';
import { PrincipalService } from './principal.service';
import { ThemeService } from './theme.service';
import { UpdateService } from './update.service';
import { I18NextModule } from 'angular-i18next';
import { UrlService } from './url.service';
import { UserActivityService } from './user-activity.service';

@NgModule({
    exports: [GuardModule, ServiceWorkerModule],
    imports: [GuardModule, ServiceWorkerModule.register('/ngsw-worker.js'), I18NextModule],
    providers: [
        CacheService,
        EnvironmentService,
        FeatureDetectService,
        MddHttpService,
        MediaQueryService,
        PrincipalService,
        ThemeService,
        UpdateService,
        UrlService,
        UserActivityService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class CoreModule {}
